/**
 * @extends com.inq.flash.client.control.messagehandlers.TypingActivityHandler
 * @constructor
 */
com.inq.flash.client.control.messagehandlers.CMSDKTypingActivityHandler = function() {
	this.constructor.__super__.call(this);
};
$hxClasses.extend(com.inq.flash.client.control.messagehandlers.TypingActivityHandler,com.inq.flash.client.control.messagehandlers.CMSDKTypingActivityHandler,"com.inq.flash.client.control.messagehandlers.CMSDKTypingActivityHandler")

com.inq.flash.client.control.messagehandlers.CMSDKTypingActivityHandler.prototype.processMessage = function(message) {
	this.controller.onNewChatRouterMessage(message);
};


